import React from 'react';
import './index.css';

const StepCard = ({ stepNumber, title, description }) => {
  return (
    <div className="step-card">
      <div className="step-number-badge">
        <span className="step-number">{stepNumber}</span>
      </div>
      <div className="step-content">
        <p className="step-title">{title}</p>
        <p className="step-description">{description}</p>
      </div>
      <div className="progress-container">
        <div className="progress-bar"></div>
      </div>
    </div>
  );
};

export default StepCard;
